export default __webpack_public_path__ + "static/media/apiPartnerLogo.96d7c064.png";